<template>
  <div>
    <template v-if="party.ageGroup == 0">
      Esse evento é <b>livre</b> para todos os públicos.
    </template>
    <template v-else>
      Este evento é para maiores de <b>{{ party.ageGroup }} anos</b>.

      <template v-if="!!party.ageWithParent">
        Jovens {{ ageDiference > 2 ? "entre" : "de" }}
        <b
          >{{ party.ageWithParent }}
          <template v-if="ageDiference >= 2">
            {{ ageDiference == 2 ? "ou" : "e" }}
            {{ party.ageGroup - 1 }}
          </template>
          anos</b
        >
        podem entrar acompanhados pelos pais ou responsáveis ou com uma carta de
        autorização assinada pelos mesmos.
      </template>
    </template>
  </div>
</template>

<script>
export default {
  computed: {
    ageDiference() {
      const age = this.party.ageGroup;
      const ageWithParent = this.party.ageWithParent;
      return age - ageWithParent;
    },
  },
  props: {
    party: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style>
</style>